// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PizzaValidation_wrapper__3qE5K","pageContent":"PizzaValidation_pageContent__3kuXr","separator":"PizzaValidation_separator__2aZA1"};